export default __webpack_public_path__ + "static/media/logo_sigue_latiendo.1127a029.svg";